import { Component, Input, forwardRef, ElementRef, ViewChild, Output, EventEmitter, HostListener, ContentChild, TemplateRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'event-picker',
  host: {
    '[class.event-picker]': 'someAttr',
  },
  template: `
    <div class="input-group">
      <input #input type="text" class="{{ cssClass }}" aria-describedby="button-addon2" />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="pickEvent()" type="button" id="button-addon2">Pick</button>
      </div>
    </div>

    <ng-template #content let-modal>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Choose a breakout session</h5>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body" style="overflow-y:scroll; height: calc(100vh - 150px)">
          <div class="card mb-2" *ngFor="let item of data">
            <div class="card-body p-4" [ngClass]="item.id == selectedDataItem?.id ? 'selected-event' : ''">
              <div class="row">
                <div class="col-md-10">
                  <h4>{{ item.title }}</h4>
                  <h6>
                    <span style="text-wrap:none" class="mr-4" *ngFor="let instructor of item.allInstructors"><i class="fas fa-user-circle"></i> {{ instructor }}</span>
                  </h6>
                  <bxl-ceu-display [CEUs]="item.ceus"></bxl-ceu-display>
                  <span class="d-block small mt-0 mb-3"
                      ><span class="paper-tag" *ngFor="let tag of item.tags">{{ tag }}</span></span
                    >
                </div>
                <div class="col-md-2 text-right">
                  <button type="button" class="btn btn-xs btn-admin-primary" (click)="select(item)">Select</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" [editorHTML]="item.description">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EventPickerControl),
      multi: true,
    },
  ],
})
export class EventPickerControl implements ControlValueAccessor {
  /**
   *
   */
  constructor(private elementRef: ElementRef, private modal: NgbModal, private renderer: Renderer2) {
    this.cssClass = elementRef.nativeElement.getAttribute('class');

    elementRef.nativeElement.setAttribute('class', '');
  }

  @Input() data: any[];
  @Input() value: any;
  cssClass: string = '';
  @Input() textField: string;
  @Input() valueField: string;
  @Input() valuePrimitive: boolean = false;

  @Output() change = new EventEmitter<any>();

  selectedDataItem: any;

  @ViewChild('content') modalContent: TemplateRef<ElementRef>;
  @ViewChild('input') input: ElementRef;
  private modalRef: NgbModalRef;

  propagateChange = (_: any) => {};
  propagateTouch = () => {};

  writeValue(value: any): void {
    this.value = value;

    if (this.valuePrimitive) {
      this.selectedDataItem = this.data.find((x) => x[this.valueField] == value);
    }

    if (this.selectedDataItem) {
      this.renderer.setProperty(this.input.nativeElement, 'value', this.selectedDataItem[this.textField]);
    }
  }

  select(value: any) {
    this.selectedDataItem = value;
    if (this.valuePrimitive) {
      this.value = value[this.valueField];
    } else {
      this.value = value;
    }
    this.renderer.setProperty(this.input.nativeElement, 'value', this.selectedDataItem[this.textField]);

    this.onChange();
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }

  getDisplayValue() {
    if (this.valuePrimitive) {
      return this.value;
    }

    var item = this.data.find((x) => x[this.valueField] == this.value);
    if (item) {
      return item[this.textField];
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  onChange() {
    var value = this.valuePrimitive ? this.selectedDataItem[this.valueField] : this.selectedDataItem;
    this.propagateChange(value);
    this.propagateTouch();
    this.change.emit(value);
  }

  onTouch() {
    this.propagateTouch();
  }

  pickEvent() {
    this.modalRef = this.modal.open(this.modalContent, { size: 'xl' });
  }
}
